import React from 'react';
import { FileText, ArrowRight } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../translations/translations';
import './ProposalCTA.css';

const ProposalCTA = () => {
  const { language } = useLanguage();
  const formLink = "https://forms.gle/n7stFEiwwC7L5MM87";
  
  const t = translations[language];

  return (
    <section className="proposal-cta section" id="proposal">
      <div className="proposal-enhanced-wrapper">
        <div className="container">
          <div className="proposal-enhanced-content">
            <div className="proposal-visual-accent">
              <div className="accent-dot accent-dot-1"></div>
              <div className="accent-dot accent-dot-2"></div>
              <div className="accent-line"></div>
            </div>

            <div className="proposal-main-content">
              <div className="proposal-header-enhanced">
                <h2 className="proposal-enhanced-headline">
                  {t.proposalCta.headline}
                </h2>
                <p className="proposal-enhanced-subtext">
                  {t.proposalCta.subtext}
                </p>
              </div>
              
              <div className="proposal-action-enhanced">
                <a 
                  href={formLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-proposal-enhanced"
                >
                  <FileText size={22} />
                  <span>{t.proposalCta.button}</span>
                  <ArrowRight size={20} className="btn-arrow" />
                </a>
                
                <p className="proposal-enhanced-microcopy">
                  {t.proposalCta.microcopy}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProposalCTA;
